import { SettingsNav } from '@/ui'
import { SettingsHeading } from '../shared'
import { HubspotLinkSection } from './organization/hubspot-link-section'

export function ExternalConnectionsPage() {
	return (
		<SettingsNav active="external-connections">
			<SettingsHeading>External Connections</SettingsHeading>
			<p className="max-w-[600px] text-gray-600">
				Manage connections between this organisation and external services.
			</p>
			<HubspotLinkSection />
		</SettingsNav>
	)
}
